import React from 'react';
import { HbrIcon, HbrTag } from '@harbor/elements-react-standalone';
import { lightning } from '@harbor/elements/icons';

const styles = {
  menuItem: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    padding: 14,
    whiteSpace: 'nowrap',
  } as React.CSSProperties,
  prefix: {
    flex: '0 0 20px',
    width: 20,
    height: 20,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'var(--hbr-color-neutral-icon, #7E868F)',
  } as React.CSSProperties,
  menuBody: {
    flex: '1 1 auto',
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    minWidth: 0,
  } as React.CSSProperties,
  heading: {
    fontSize: 'var(--hbr-font-size-sm, 14px)',
    color: 'var(--hbr-color-neutral-text-weak, #596069)',
  } as React.CSSProperties,
  labelBold: {
    fontWeight: 600,
    fontSize: 'var(--hbr-font-size-sm, 14px)',
    lineHeight: '20px',
  } as React.CSSProperties,
  suffix: {
    flex: '0 0 auto',
    display: 'flex',
    alignItems: 'center',
  } as React.CSSProperties,
};

const UserProfileSystemStatusSection: React.FC = () => (
  <div style={styles.menuItem}>
    <div style={styles.prefix}>
      <HbrIcon asset={lightning} style={{ fontSize: 20 }} />
    </div>

    <div style={styles.menuBody}>
      <div style={styles.heading}>System status</div>
      <div style={styles.labelBold}>Healthy</div>
    </div>

    <div style={styles.suffix}>
      <HbrTag sentiment="success">Healthy</HbrTag>
    </div>
  </div>
);

export default UserProfileSystemStatusSection;